import { Controller } from "stimulus";

// Closes the comment edit modal after the form is saved successfully. On a
// validation error the turbo-stream re-renders the form inside the modal frame,
// so we keep the modal open (success === false) for the user to fix and resend.
export default class extends Controller {
  static values = { modal: String };

  saved(event) {
    if (!event.detail || !event.detail.success) return;

    $(this.modalValue).modal("hide");
  }
}
